var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Model from './Model';
import { observable } from 'mobx';
import SchemaTriggerType from '../data/SchemaTriggerType';
import SchemaTriggerIntervalValueType from '../data/SchemaTriggerIntervalValueType';
/**
 *
 */
var ServiceSchemaModel = /** @class */ (function (_super) {
    __extends(ServiceSchemaModel, _super);
    /**
     *
     * @param data
     */
    function ServiceSchemaModel(data) {
        return _super.call(this, data) || this;
    }
    /**
     *
     * @param data
     */
    ServiceSchemaModel.prototype.initialize = function (data) {
        // Set defaults
        this.triggerType = SchemaTriggerType.INTERVAL; // SchemaTriggerType
        this.triggerIntervalValueType = SchemaTriggerIntervalValueType.OPERATIONAL_HOURS; // SchemaTriggerIntervalValueType
        this.triggerIntervalValue = 0;
        this.triggerReminderBeforeInterval = 0;
        this.triggerReminderBeforeIntervalValue = 0;
    };
    /**
     *
     * @param data
     */
    ServiceSchemaModel.prototype.update = function (data) {
        var _this = this;
        if (!data)
            return;
        var keys = Object.keys(data);
        keys.map(function (key) {
            switch (key) {
                case 'schemaId':
                    _this.id = data[key];
                    break;
                default:
                    _this[key] = data[key];
            }
        });
    };
    __decorate([
        observable
    ], ServiceSchemaModel.prototype, "id", void 0);
    __decorate([
        observable
    ], ServiceSchemaModel.prototype, "name", void 0);
    __decorate([
        observable
    ], ServiceSchemaModel.prototype, "description", void 0);
    __decorate([
        observable
    ], ServiceSchemaModel.prototype, "triggerType", void 0);
    __decorate([
        observable
    ], ServiceSchemaModel.prototype, "triggerIntervalValueType", void 0);
    __decorate([
        observable
    ], ServiceSchemaModel.prototype, "triggerIntervalValue", void 0);
    __decorate([
        observable
    ], ServiceSchemaModel.prototype, "triggerReminderBeforeInterval", void 0);
    __decorate([
        observable
    ], ServiceSchemaModel.prototype, "triggerReminderBeforeIntervalValue", void 0);
    return ServiceSchemaModel;
}(Model));
export default ServiceSchemaModel;
